import React from 'react';
import { Container } from 'mdbreact';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

class PageVideo extends React.Component {
  static get propTypes() {
    return {
      propTitle: PropTypes.string,
      onActivated: PropTypes.func
    };
  }

  componentDidMount() {
    console.log(`PageVideo::componentDidMount with props: ${this.props}`);
    console.log(this.props);
    this.props.onActivated(this.props.propTitle);
  }

  render() {
    console.log('PageVideo::render');
    return (
      <Container className="mt-5">
        <div className="no-margin">
          <h1> My Video </h1>
        </div>
      </Container>

    );
  }
}

export default withRouter(PageVideo);




// WEBPACK FOOTER //
// ./src/Pages/Video/page-video.js